/* ==================================================

   TOURNAMENT VISUALS — AUTHORITATIVE (ABSOLUTE FINAL)

   ================================================== */

import sixNationsMen from "../assets/images/tournaments/six-nations-men-2026.jpg";

import sixNationsWomen from "../assets/images/tournaments/six-nations-women-2026.jpg";

import nationsChampionship from "../assets/images/tournaments/nations-championship-2026.jpg";

import pacificMen from "../assets/images/tournaments/pacific-men.jpg";

import bledisloe from "../assets/images/tournaments/bledisloe.jpg";

import greatestRivalry from "../assets/images/tournaments/greatest-rivalry-2026.jpg";

import internationalTestsMen from "../assets/images/tournaments/international-tests-men-hero.jpg";

import internationalTestsWomen from "../assets/images/tournaments/international-tests-women-hero.jpg";

/* 🆕 URC */

import urcHero from "../assets/images/domestic/urc-rugby.jpg";

/* 🆕 GALLAGHER PREM */

import premiershipHero from "../assets/images/domestic/premier-league.jpg";

import epcrChallengeCupHero from "../assets/images/domestic/epcr-challengecup.jpg";

import investecCupHero from "../assets/images/domestic/investec-cup.jpg";

import npcHero from "../assets/images/domestic/npc.jpg";

/* 🔥 WXV (INTENTIONAL REUSE — LOCKED) */

import wxvHero from "../assets/images/tournaments/nations-championship-2026.jpg";

/* 🆕 WXV CHALLENGER */

import wxvChallengerWomen from "../assets/images/raz/wxv-challenger-women.jpg";

/* 🆕 SVNS */

import svnsHero from "../assets/images/tournaments/svns-2026.jpg";

import fallbackHero from "../assets/images/tournaments/default-tournament.jpg";

/* ================= TYPES ================= */

export type HeroLayout =
  | "default"
  | "contained"
  | "top";

export type AnthemMode =
  | "standard"
  | "global"
  | "six-nations"
  | "rivalry";

export interface TournamentVisual {
  conceptId: string;
  heroImageMen?: string;
  heroImageWomen?: string;
  heroLayout?: HeroLayout;
  logo?: string;
  anthemMode?: AnthemMode;
}

/* ==================================================

   VISUAL MAP — COMPLETE (NO UNUSED ENTRIES)

   ================================================== */

export const tournamentVisuals: TournamentVisual[] = [

  // ================= SIX NATIONS =================

  {
    conceptId: "six-nations",
    heroImageMen: sixNationsMen,
    heroImageWomen: sixNationsWomen,
    logo: sixNationsMen,
    anthemMode: "six-nations",
  },

  {
    conceptId: "six-nations-women",
    heroImageWomen: sixNationsWomen,
    logo: sixNationsWomen,
    anthemMode: "six-nations",
  },

  // ================= NATIONS CHAMPIONSHIP =================

  {
    conceptId: "nations-championship",
    heroImageMen: nationsChampionship,
    heroImageWomen: nationsChampionship,
    logo: nationsChampionship,
    heroLayout: "contained",
    anthemMode: "global",
  },

  // ================= PACIFIC (MEN) =================

  {
    conceptId: "pacific-nations",
    heroImageMen: pacificMen,
    logo: pacificMen,
    heroLayout: "contained",
    anthemMode: "global",
  },

  // ================= BLEDISLOE =================

  {
    conceptId: "bledisloe-cup",
    heroImageMen: bledisloe,
    logo: bledisloe,
    heroLayout: "contained",
    anthemMode: "rivalry",
  },

  // ================= RIVALRY TOUR =================

  {
    conceptId: "sa-nz-rival-tour",
    heroImageMen: greatestRivalry,
    heroImageWomen: greatestRivalry,
    logo: greatestRivalry,
    heroLayout: "contained",
    anthemMode: "rivalry",
  },

  // ================= INTERNATIONAL TESTS =================

  {
    conceptId: "international-tests",
    heroImageMen: internationalTestsMen,
    heroImageWomen: internationalTestsWomen,
    heroLayout: "contained",
    anthemMode: "global",
  },

  // ================= UNITED RUGBY CHAMPIONSHIP =================

  {
    conceptId: "urc",
    heroImageMen: urcHero,
    logo: urcHero,
    heroLayout: "contained",
    anthemMode: "global",
  },

  // ================= GALLAGHER PREM =================

  {
    conceptId: "premiership",
    heroImageMen: premiershipHero,
    logo: premiershipHero,
    heroLayout: "contained",
    anthemMode: "global",
  },

  // ================= EPCR CHALLENGE CUP =================

  {
    conceptId: "challenge-cup",
    heroImageMen: epcrChallengeCupHero,
    logo: epcrChallengeCupHero,
    heroLayout: "contained",
    anthemMode: "global",
  },

  {
  conceptId: "champions-cup",
  heroImageMen: investecCupHero,
  logo: investecCupHero,
  heroLayout: "contained",
  anthemMode: "global",
},

{
  conceptId: "npc",
  heroImageMen: npcHero,
  logo: npcHero,
  heroLayout: "contained",
  anthemMode: "global",
},

  // ================= WXV 1 =================

  {
    conceptId: "wxv1",
    heroImageWomen: wxvHero,
    logo: wxvHero,
    heroLayout: "contained",
    anthemMode: "global",
  },

  // ================= WXV CHALLENGER =================

  {
    conceptId: "wxv-challenger",
    heroImageWomen: wxvChallengerWomen,
    logo: wxvChallengerWomen,
    heroLayout: "contained",
    anthemMode: "global",
  },

  // ================= SVNS =================

  {
    conceptId: "svns",
    heroImageMen: svnsHero,
    heroImageWomen: svnsHero,
    logo: svnsHero,
    heroLayout: "contained",
    anthemMode: "global",
  },

];

/* ==================================================

   RESOLVER (HARDENED — ZERO UI FAILURE)

   ================================================== */

export function getTournamentVisual(conceptId: string): TournamentVisual {

  const visual = tournamentVisuals.find(
    (v) => v.conceptId === conceptId
  );

  if (!visual) {
    return {
      conceptId: "fallback",
      heroImageMen: fallbackHero,
      heroImageWomen: fallbackHero,
      logo: fallbackHero,
      heroLayout: "default",
      anthemMode: "standard",
    };
  }

  return {
    ...visual,
    heroImageMen: visual.heroImageMen || fallbackHero,
    heroImageWomen: visual.heroImageWomen || fallbackHero,
    logo: visual.logo || fallbackHero,
  };
}